// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton_skeleton__gUMqh","loading":"skeleton_loading__XZoZ6"};